export default class Language {
    constructor(
        public readonly name: string,
        public readonly img: string,
    ) {}
}
